var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66738 4.99992V7.49992H4.16738V4.99992H6.66738ZM2.50072 3.33325V9.16658H8.33407V3.33325H2.50072ZM10.8341 3.33325H17.5007V4.99992H10.8341V3.33325ZM10.8341 9.16658H17.5007V10.8333H10.8341V9.16658ZM10.8341 14.9999H17.5007V16.6666H10.8341V14.9999ZM8.92332 13.5058L7.74479 12.3273L5.00072 15.0714L3.50663 13.5773L2.32812 14.7558L5.00072 17.4284L8.92332 13.5058Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.b51a9ec2ee5b5bcec78f738c2e72cda9.svg";
export { ForwardRef as ReactComponent };